(function () {
  function buildMediaHtml(media) {
    if (!media) return '<p>Unsupported media type</p>';
    if (media.mediaType === 'image') {
      return '<img src="' + media.src + '" alt="' + (media.alt || '') + '" class="g1b-main-image" loading="lazy">';
    }
    if (media.mediaType === 'video') {
      var video = '<video class="g1b-hosted-video" controls playsinline>';
      (media.sources || []).forEach(function (source) {
        video += '<source src="' + source.url + '" type="' + source.mime_type + '">';
      });
      video += 'Your browser does not support the video tag.</video>';
      return video;
    }
    return '<p>Unsupported media type</p>';
  }

  function initMediaRegion(mediaRegion) {
    var sectionId = mediaRegion.id.replace('g1b-media-region-', '');
    var mainMediaContainer = mediaRegion.querySelector('#g1b-main-media-' + sectionId);
    var thumbButtons = Array.from(mediaRegion.querySelectorAll('.g1b-thumb[data-media-id]'));
    var mediaMapTag = document.querySelector('script[data-g1b-mediamap-' + sectionId + ']');

    if (!mainMediaContainer || !thumbButtons.length || !mediaMapTag) return;

    var mediaData = {};
    try {
      mediaData = JSON.parse(mediaMapTag.textContent || '{}');
    } catch (error) {
      return;
    }

    thumbButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mediaId = btn.getAttribute('data-media-id');
        var media = mediaData[mediaId];
        if (!media) return;

        mainMediaContainer.innerHTML = buildMediaHtml(media);

        if (media.mediaType === 'image') {
          mainMediaContainer.style.setProperty('--bg-image', 'url(' + media.src + ')');
        } else {
          mainMediaContainer.style.removeProperty('--bg-image');
        }

        thumbButtons.forEach(function (button) {
          button.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });

    var prevBtn = mediaRegion.querySelector('.g1b-thumb-nav--prev');
    var nextBtn = mediaRegion.querySelector('.g1b-thumb-nav--next');

    function goToImage(direction) {
      var currentIndex = thumbButtons.findIndex(function (btn) {
        return btn.classList.contains('is-active');
      });
      if (currentIndex < 0) currentIndex = 0;

      var total = thumbButtons.length;
      var newIndex = direction === 'next'
        ? (currentIndex + 1) % total
        : (currentIndex - 1 + total) % total;

      thumbButtons[newIndex].click();
      thumbButtons[newIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goToImage('prev'); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goToImage('next'); });
    }

    // --- Sticky CTA ---
    var stickyCta = document.getElementById('g1b-sticky-cta-' + sectionId);
    var buyPanel = document.getElementById('g1b-buy-' + sectionId);
    if (!stickyCta || !buyPanel) return;

    function handleScroll() {
      if (window.innerWidth > 1024) {
        stickyCta.classList.remove('is-visible');
        return;
      }
      var rect = buyPanel.getBoundingClientRect();
      var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
      stickyCta.classList.toggle('is-visible', outOfView);
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    handleScroll();
  }

  var regions = document.querySelectorAll('[id^="g1b-media-region-"]');
  regions.forEach(initMediaRegion);
})();
